export default __webpack_public_path__ + "media/images/features/ja/tsubetsu-1d55ccefaedc4f813ed83b1d11b4cf94.jpg";